import { create } from 'zustand';

const useModelMappingStore = create((set, get) => ({
  // ==================== STATE ====================
  // Layer Management
  layerRegistry: {
    static: {},
  },
  visibleLayers: {},

  // Map References (for programmatic layer selection)
  mapInstance: null,
  layerGroupsRef: null,

  // Feature Selection
  selectedFeature: null,

  // Pending Features (for supervision)
  pendingFeatures: [],

  // ==================== COMPUTED PROPERTIES ====================
  get selectedTAZ() {
    return get().selectedFeature?.TAZ || null;
  },

  // ==================== LAYER ACTIONS ====================
  setStaticLayer: (layerKey, geoJsonData) => {
    set((state) => ({
      layerRegistry: {
        ...state.layerRegistry,
        static: {
          ...state.layerRegistry.static,
          [layerKey]: geoJsonData,
        },
      },
    }));
  },

  removeStaticLayer: (layerKey) => {
    set((state) => {
      const { [layerKey]: removed, ...remaining } = state.layerRegistry.static;
      return {
        layerRegistry: {
          ...state.layerRegistry,
          static: remaining,
        },
      };
    });
  },

  setLayerVisibility: (layerKey, visible) => {
    set((state) => ({
      visibleLayers: {
        ...state.visibleLayers,
        [layerKey]: visible,
      },
    }));
  },

  toggleLayerVisibility: (layerKey) => {
    set((state) => ({
      visibleLayers: {
        ...state.visibleLayers,
        [layerKey]: !state.visibleLayers[layerKey],
      },
    }));
  },

  clearLayerRegistry: () => {
    set({
      layerRegistry: {
        static: {},
      },
      visibleLayers: {},
    });
  },

  // ==================== MAP REFERENCE ACTIONS ====================
  setMapReferences: (mapInstance, layerGroupsRef) => {
    set({
      mapInstance,
      layerGroupsRef,
    });
  },

  clearMapReferences: () => {
    set({
      mapInstance: null,
      layerGroupsRef: null,
    });
  },

  // ==================== FEATURE SELECTION ACTIONS ====================
  setSelectedFeature: (feature) => {
    set({
      selectedFeature: feature,
    });
  },

  clearSelectedFeature: () => {
    set({
      selectedFeature: null,
    });
  },

  // ==================== PENDING FEATURES ACTIONS ====================
  setPendingFeatures: (features) => {
    set({ pendingFeatures: features });
  },

  addPendingFeature: (feature) => {
    set((state) => ({
      pendingFeatures: [...state.pendingFeatures, feature],
    }));
  },

  removePendingFeature: (taz) => {
    set((state) => ({
      pendingFeatures: state.pendingFeatures.filter((f) => f.TAZ !== taz),
    }));
  },

  // ==================== CLEANUP ====================
  clearAll: () => {
    set({
      // Layer management
      layerRegistry: {
        static: {},
      },
      visibleLayers: {},

      // Map references
      mapInstance: null,
      layerGroupsRef: null,

      // Feature selection
      selectedFeature: null,

      // Pending features
      pendingFeatures: [],
    });
  },
}));

export default useModelMappingStore;